module.exports = __webpack_public_path__ + "static/media/LHSlidingOutDark.66c51d03.svg";